import Media from '@/components/_blog-updates/Media';
import { FC } from 'react';

export type SidebarMediaProps = {
  isImage?: boolean;
  isVideo?: boolean;
  caption?: string;
  description?: string;
  descriptionLinkText?: string;
  descriptionLinkHref?: string;
  imageSrc?: string;
  videoSrc?: string;
  playButtonText?: string;
  videoDuration?: string;
}

const SidebarMedia: FC<SidebarMediaProps> = ({
  isImage = false,
  isVideo = false,
  caption,
  description,
  descriptionLinkText,
  descriptionLinkHref,
  imageSrc,
  videoSrc,
  playButtonText,
  videoDuration,
}) => {

  return (
    <div className="flex flex-col gap-3">
      <Media
        isImage={isImage}
        isVideo={isVideo}
        caption={caption}
        imageSrc={imageSrc}
        videoSrc={videoSrc}
        playButtonText={playButtonText}
        videoDuration={videoDuration}
      />
      <p className="text-editorialP1 font-serif text-gray-800">
        {description} <a href={descriptionLinkHref} className="link-underline">{descriptionLinkText}</a>
      </p>
    </div>
  );
};

export default SidebarMedia;
